import zoonFooter from './zoonFooter.vue'

const zoonFooters = {
    install(Vue){
        Vue.component('zoonFooter',zoonFooter)
    }
}
export default zoonFooters